export interface Authentication {
  authentication: boolean;
}

export const isAuthenticated = true;
